module.exports = __webpack_public_path__ + "img/slideshow_4.3ec434e8.jpg";